<template>
<div class="Investment-box depositbox Liabilities-card-section">
    <ul class="breadcrumbs-list">
      <a  @click="backButton"><li>Liabilities </li></a>
       <a  @click="liabilityDashbord"><li>&nbsp;>&nbsp;Liabilities Dashboard</li></a>
      <li>&nbsp;>&nbsp;Dashboard</li>
    </ul>
    <div class="head-text">
        <h1></h1>
    </div>
    <div class="card-box">
        <h4>Select your option</h4>
      <v-row>
        <template>
          <v-card
            v-for="categoryList in category"
            :key="categoryList.id"
            class="boxs"
            outlined
            @click="uploadUsingExperianStepI(categoryList.id,categoryList.jump_to_router)"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline">
 
                    <v-row>
                      <v-col>
                        <p>{{categoryList.tot_count}}</p>
                      </v-col>
                      <v-col>
                          <v-img
                      max-height="58"
                      max-width="50"
                      :src="webIcon + categoryList.web_icon"
                          >
                          </v-img>
                        </v-col>
                    </v-row>
                </div>
                <v-list-item-title>{{categoryList.subcategory_name}}</v-list-item-title>
              </v-list-item-content>
              <v-btn @click="uploadUsingExperianStepI(categoryList.id,categoryList.jump_to_router)" text> 
                <v-img
                  max-height="30"
                  max-width="30"
                  src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                >
                </v-img>
              </v-btn>
            </v-list-item>
          </v-card>
        </template>
      </v-row>
    </div>
    <div class="text-center ">
        <v-dialog
          v-model="dialogFirst"
          width="500">
          <v-card class="secure-modal proceed-modal">
            <v-card-title class="">
              <h5>Select your option to proceed</h5>
               <v-card-actions class="close-icon">
                <v-btn
                  color="primary"
                  text
                  @click="dialog = false"
                >
                  <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
              <div style="margin-top:10px;">
                <p>Select an option to upload your liability information</p>
                <div class="button-box">
                  <v-btn class="orange-btn" @click="openManualForm()">
                    Add Manually <br/> (Assisted Mode)
                  </v-btn>
                  <v-btn class="orange-btn" @click="uploadUsingExperianStepII()">
                    Auto Update Using <br> Credit Report <br/>(Update every 45 days)
                  </v-btn>
                </div>
                
              </div>
              <div class="button-box">
                <v-btn class="orange-green" @click="checkConsent()">
                  Click here <br> to check <br> consent expiry
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSecond" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Auto Update using Experian Credit Report
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
            <div style="margin-top:10px;" >
              <p>Under this facility your liability data will be updated basis your Experian Credit Report every 45 days. You have to provide few personal details like First Name, Last Name, email ID, PAN and mobile numbe. Please note that the names enterd should be as provided in your PAN details.</p>
              <p>Once details are verified you will receive an OTP on the registered mobile number. On successful authencation through OTP you will receive Experian Credit Report on your email ID free of charge. <b>You will get your credit score free.</b></p>
              <p>Your liability data will be updated and you can view the same on the liability dashboard</p>
              <p>The credit report will be sent every 45 days. Your consent will be valid for 6 months. Post 6 months you have to provide your consent again to avail the facility.</p>
            </div>
            <form class="login-form-box register-page pricing-plan_modal-bottombox" style="text-align:center !important;">
              <v-row>
                <v-col>
                  <v-btn class="blue-btn"
                    @click="uploadUsingExperianStepIII">
                    Proceed   
                  </v-btn>
                </v-col>
              </v-row>
            </form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogThird" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Auto Update using Experian Credit Report
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
            <div style="margin-top:10px;" >
              <span><b>Step 1:</b></span>
              <p>Provide the few details of the member you want to update the liability data like</p>
              <p>
                <ol>
                  <li>Name of the member</li>
                  <li>Mobile Number</li>
                  <li>Email ID</li>
                  <li>PAN</li>
                </ol>
                <span>You will receive an OTP on mobile number to validate</span>
              </p>

              <span><b>Step 2:</b></span>
              <p>Provide consent on the term Terms and Conditions</p>

              <span><b>Step 3:</b></span>
              <p>Experian Credit Report will be sent to the email ID once every 45 days</p>

              <span><b>Step 4:</b></span>
              <p>Dashboard will be auto updated with the data once every 45 days</p>
            </div>
            <form class="login-form-box register-page pricing-plan_modal-bottombox" style="text-align:center !important;">
              <v-row>
                <v-col>
                  <v-btn class="blue-btn"
                    @click="uploadUsingExperianStepIV">
                    Proceed   
                  </v-btn>
                </v-col>
              </v-row>
            </form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogFourth" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Auto Update using Experian Credit Report
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
                <v-form
                  ref="memberForm"
                  v-model="valid"
                  @submit.prevent="submit"
                  lazy-validation
                >
                  <v-select
                    v-model="select"
                    :items="member_items"
                    :rules="[v => !!v || 'Item is required']"
                    item-value="id"
                    item-text="name"
                    name = "member_name"
                    id   = "member_name"
                    label="Select Member"
                    @change="setMemberData($event)"
                    required
                  ></v-select>

                  <v-text-field
                    v-model="mobile_no"
                    :counter="10"
                    :rules="mobileNoRules"
                    label="Enter Mobile No"
                    name="mobile_no"
                    id="mobile_no"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="Enter Email"
                    name="email"
                    id="email"
                    required
                  ></v-text-field>

                  <v-text-field
                    v-model="pancard"
                    :counter="10"
                    :rules="pancardRules"
                    label="Enter PAN No"
                    name="pancard"
                    id="pancard"
                    required
                  ></v-text-field>

                  <v-btn
                    :disabled="!valid"
                    color="warning"
                    class="mr-4"
                    type="submit"
                  >
                    Validate
                  </v-btn>
                </v-form>   
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogFifth" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Auto Update using Experian Credit Report
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
            <div style="margin-top:10px;" >
              <p>You hereby consent to Nimeya Technologies Pvt Ltd being appointed as your authorised representative to receive your Credit information from Experian CIC for the purposse of updating your liability data every 45 days for next 6 month</p>
              <p>Request to proceed and read Terms and Conditions and provide your acceptance</p>
              <p style="text-align:center"><v-img max-height="100"  :src=" experian_logo" :lazy-src=" experian_logo"> </v-img>
              </p>
            </div>
            <form class="login-form-box register-page pricing-plan_modal-bottombox" style="text-align:center !important;">
              <v-row>
                <v-col>
                  <v-btn class="blue-btn"
                    @click="uploadUsingExperianStepV">
                    Proceed   
                  </v-btn>
                </v-col>
              </v-row>
            </form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSixth" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Auto Update using Experian Credit Report
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
            <div style="margin-top:10px;" >
              <p style="text-align:center"><span style="font-size:23px;"><b>Terms and Conditions</b></span></p>
              <p>Nimeya shall access your Credit Information as your authorized representative and Nimeya shall use the Credit Information for limited End Use Purpose consisting of and in relation to the services proposed to be availed by you from Nimeya.</p>
              <p>We shall not aggregate, retain, store, copy, reproduce, republish, upload, post, transmit, sell or rent the Credit Information to any other person and the same cannot be copied or reproduced other than as agreed herein and in furtherance to <b>CICRA</b></p>
              <p>The Parties agree to protect and keep confidential the Credit Information both online and offline. The Credit Information shared by you, or received on by us on your behalf shall be destroyed, purged, erased promptly within 1 (one) Business Day of upon the completion of the transaction/ End Use Purpose for which the Credit Information report was procured</p>
              <p><span style="font-size:23px;"><b>Governing Law and Jurisdiction</b></span></p>
              <p>The relationship between you and Nimeya shall be governed by laws of India and all claims or disputes arising there from shall be subject to the exclusive jurisdiction of the courts of Mumbai.</p>
              <p><span style="font-size:23px;"><b>Definitions:</b></span></p>
              <p style="font-size:16px">Capitalized terms used herein but not defined above shall have the following meanings:</p>
              <p style="font-size:16px"><b>“Business Day”</b> means a day (other than a public holiday) on which banks are open for general business in Mumbai.</p>
              <p style="font-size:16px"><b>“Credit Information Report”</b> means the credit information / scores/ aggregates / variables / inferences or reports which shall be generated by Experian.</p>
              <p style="font-size:16px"><b>“Credit Score”</b> means the score which shall be mentioned on the Credit Information Report which shall be computed by Experian.</p>
              <p style="font-size:16px"><b>“CICRA”</b> shall mean the Credit Information Companies (Regulation) Act, 2005 read with the Credit Information Companies Rules, 2006 and the Credit Information Companies Regulations, 2006, and shall include any other rules and regulations prescribed thereunder.</p>
              <p style="font-size:16px"> PLEASE READ THE ABOVEMENTIONED TERMS AND CONDITIONS AND CLICK ON <b>“ACCEPT”</b>. FOLLOWED BY THE LINK BELOW TO COMPLETE THE AUTHORISATION PROCESS/ "SUBMIT YOUR SELF ATTESTED KYC DOCUMENTATION IN PHYSICAL COPIES" FOR SHARING OF YOUR CREDIT INFORMATION BY EXPERIAN WITH XYZ IN ITS CAPACITY AS YOUR AUTHORISED REPRESENTATIVE.</p>
              <p style="font-size:16px"> BY CLICKING <b>“ACCEPT”</b> YOU AGREE AND ACCEPT THE DISCLAIMERS AND TERMS AND CONDITIONS SET OUT HEREIN.</p>
            </div>
            <form class="login-form-box register-page pricing-plan_modal-bottombox" style="text-align:center !important;">
              <v-row class="register-checkbox" style="margin-left:230px">
                  <v-checkbox
                    id="checkboxfield"
                    required
                    color="orange"
                    checked="checked"
                    ref="checkboxfield"
                    v-model="checkboxfield"
                    @click="agree($event)"
                  ></v-checkbox>I agree to terms & conditions
              </v-row>
              <span style="color:red !important;" v-if="checkbox_error">Please agree to terms & conditions</span>
              <v-row>
                <v-col>
                  <v-btn class="blue-btn"
                    @click="uploadUsingExperianStepVI">
                    Proceed   
                  </v-btn>
                </v-col>
              </v-row>
            </form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSeventh" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              Verify OTP
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text style="margin-top:10px">
                  <p ><span style="font-size:15px">You will receive the OTP on the following number ending with {{masked_mob}}</span></p>
                <v-form
                  ref="submitExpOTPForm"
                  v-model="valid"
                  @submit.prevent="submitExpOTP"
                  lazy-validation
                >  

                  <v-text-field
                    v-model="exp_otp"
                    :rules="expOTPRules"
                    label="Enter OTP"
                    name="exp_otp"
                    id="exp_otp"
                    required
                  ></v-text-field>

                  <v-btn
                    :disabled="!valid"
                    color="warning"
                    class="mr-4"
                    type="submit"
                  >
                    Confirm
                  </v-btn>
                  <v-btn
                    
                    color="error"
                    class="mr-4"
                    @click="sendExpOtp()"
                    
                  >
                    Resend
                  </v-btn>
                  <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
                  <p style="color:blue;">In case you have not received OTP in the next 5 min please press the "Resend" button.</p>
                </v-form>   
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogEightth" width="900">
          <v-card class="term-modal">
            <v-card-title class="text-h5">
              <v-card-actions class="close-icon">
                <v-btn color="primary" text @click="dialogSecond = false">
                  <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
            <div style="margin-top:10px;" >
              <p style="text-align:center"><v-img max-height="100"  :src=" exp_ok" :lazy-src=" exp_ok"> </v-img></p>
              <p style="text-align:center">Thank You</p>  
              <p style="text-align:center">The liability detail for {{exp_member_name}} have been successfully updated.</p>
              <p style="text-align:center">Check Your Experian Credit Score</p>
              <p style="text-align:center; color:#F19700; font-size:20px"><b>Your experian credit score is {{exp_credit_score}}/900</b></p>
              <p style="text-align:center">Check Your Experian Credit Score</p>
              <p style="text-align:center">You may go to the dashboard to view details. Should you want to update liability details for another member, then please click on "<b style="color:#1A407D;">Update New Member</b>" below</p>
              <p style="text-align:center">Note: You may need to update certain data fields which are not available in your Credit Report. You can use EDIT option or "Update Other Details" from Liability dashboard to update these fields</p>

            </div>
            <form class="login-form-box register-page pricing-plan_modal-bottombox" style="text-align:center !important;">
              <v-row>
                <v-col>
                  <v-btn class="blue-btn"
                    color="warning"
                    @click="uploadOtherMemberDetail()">
                    Update New Member   
                  </v-btn>
                  &nbsp;&nbsp;&nbsp;
                  <v-btn class="blue-btn"
                    @click="pushToDashboard()">
                    Go To Dashboard   
                  </v-btn>
                </v-col>
              </v-row>
            </form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="consentDialog" width="900">
            <v-card class="term-modal">
              <v-card-title class="text-h5">
                Check consent expiry dates
                <v-card-actions class="close-icon">
                  <v-btn color="primary" text @click="dialogSecond = false">
                    <v-img max-height="23" max-width="19" :src="delete_pic" :lazy-src="delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
                <div style="margin-top:10px;">
                  <div class="row">
                    <div class="col-lg-3">
                      <b>Name</b>
                    </div>

                    <div class="col-lg-3">
                      <b>Expiry Date</b>
                    </div>
                  </div>
                  <div class="row" style="font-size:13px" v-for="(consent, key) in consent_list" :key="key">
                    <div class="col-lg-3">
                      {{key + 1}} - {{consent.name}}
                    </div>
                    <div class="col-lg-4">
                      {{consent.exp_date}}
                    </div>  
                  </div>
                  <br><br><br><br>
                  <p>You need to renew your consent before expiry date to continue availing the service. To renew please click on the link</p>
                  <p>Check consent expiry dates for the members. If the consent for auto update using Experian report has expired then you need to authenticate your details.</p>  
                </div>
              </v-card-text>
            </v-card>
          </v-dialog>
      </div>
 </div>
</template>
<script>
import { POST_API, GET_API , UPDATE_USER_DETAILS} from "../../store/actions.type";
import ApiService from '../../api/api.service';
import JwtService from ".././common/jwt.service";
import { Auth } from "aws-amplify";
import axios from "axios";
import qs from 'qs'

export default {
  data: () => ({
    category:'',
    webIcon:process.env.VUE_APP_ROOT_ICONS_URL,
    delete_pic:'',
    experian_logo: process.env.VUE_APP_ROOT_ICONS_URL + 'experian_logo.png',
    exp_ok: process.env.VUE_APP_ROOT_ICONS_URL + 'exp_ok.png',
    dialogFirst:false,
    dialogSecond:false,
    dialogThird:false,
    dialogFourth:false,
    dialogFifth:false,
    dialogSixth:false,
    dialogSeventh:false,
    dialogEightth:false,
    jump_to_router:'',
    id:'',
    member_name:'',
    isFormInvalid:true,
    mobile_no:'',
    buttonErrorMessage:'',
    member_list:[],
    error_mobile_no:'',
    valid: true,
    name: '',
    exp_member_name:'',
    pancard:'',
    checkboxfieldsErrors:'',
    checkboxfield:'',
    checkbox_error:false,
    stgOneHitId:'',
    stgTwoHitId:'',
    exp_member_id:'',
    exp_otp:'',
    exp_credit_score:'',
    mobileNoRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    pancardRules: [
      v => !!v || 'PAN Card is required',
      v =>  /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || 'PAN card must be valid',
    ],
    expOTPRules: [
      v => !!v || 'OTP is required'
    ],
    select: null,
    member_items: [],
    checkbox: false,
    masked_mob:'XXXXXXX',
    consentDialog:false,
    login_user_name:'',
    consent_list:[]
  }),
  mounted (){
    Fire.$on("categoryData", () => {
    this.categoryData();
    });
    this.categoryData(); //parseCategoryData;
  },
  methods: {
    openManualForm(){
      if(this.id == 1){
        this.$router.push({ name: this.jump_to_router})
      }
      else if(this.id == 2){
        this.$router.push({ name: this.jump_to_router})
      }
      else if(this.id == 4){
        this.$router.push({ name: this.jump_to_router})
      }
      else if(this.id == 11){
        this.$router.push({ name: "add-home-loan",params: { form_id:this.id}})
      }
      else if(this.id == 12){
        this.$router.push({ name: "personal-loan-add",params: { form_id:this.id}})
      }
      else if(this.id == 14){
        this.$router.push({ name: "consumer-loan-add",params: { form_id:this.id}})
      }
      else if(this.id == 15){
        this.$router.push({ name: "student-loan-add",params: { form_id:this.id}})
      }
      else if(this.id == 17){
        this.$router.push({ name: "car-loan-add",params: { form_id:this.id}})
      }
      else if(this.id == 18){
        this.$router.push({ name: "two-wheeler-add",params: { form_id:this.id}})
      }
      else if(this.id == 20){
        this.$router.push({ name: "add-over-draft",params: { form_id:this.id}})
      }
      else if(this.id == 19){
        this.$router.push({ name: "add-policy-loan",params: { form_id:this.id}})
      }
      else if(this.id == 16){
        this.$router.push({ name: "add-loan-against-property",params: { form_id:this.id}})
      }
      else if(this.id == 13){
        this.$router.push({ name: "add-credit-card-laon",params: { form_id:this.id}})
      }
      else{
      }
    },
    categoryData(){
      // if(this.$route.params.open_consent_exp_modal == 'yes'){
      //   this.dialogFirst = true
      // }
      Auth.currentAuthenticatedUser({
        bypassCache: false
      }).then(user => { 
        this.login_user_name = user.attributes["custom:name"];      
      })

      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      this.$store.dispatch(POST_API, {
            data: {
              aws_cognito_id:cognito_idp,
              category_id:3,
            },
            api: 'subcategory-listing',
        })
        .then((response) => {
          let categoryData = response.data;
          this.category = categoryData;
        });

        this.member_items = [];
        let response = this.$store.getters.getLiabilityFormDetail;
        response.member_list.forEach(elementData => {
          if(elementData.name !='All Users'){
            this.member_items.push({'id':elementData.id.toString(),'name':elementData.name})
          }
        });
    },

    backButton(){
      this.$router.push({ name: 'liabilities-subcategory'});
    },

    liabilityDashbord(){
      this.$router.push({ name: 'liabilities-dashboard'});
    },

    uploadUsingExperianStepI(id, jump_to_router){
      this.id              = id
      this.jump_to_router  = jump_to_router
      this.dialogFirst     = true;
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata    = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      axios.post( process.env.VUE_APP_ROOT_API+'generate-exp-token',
          formdata,{
          headers: {
            'Access-Control-Allow-Origin':'*'
          }
        }
      ).then((response) => { 
          localStorage.setItem('experian_access_token',response.data.access_token)
      }).catch(() => {});
    },

    uploadUsingExperianStepII(){
      this.dialogFirst   = false;
      this.dialogSecond  = true;
    },

    checkConsent(id){
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      let formdata    = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("user_name", this.login_user_name);
      axios.post( process.env.VUE_APP_ROOT_API+'get-consent-list',
          formdata,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin':'*'
          }
        }
      ).then((response) => { 
        this.consent_list = response.data.data
        setTimeout(()=>{this.consentDialog = true}, 500) 
      }).catch(() => {});
    },

    uploadUsingExperianStepIII(){
      this.dialogSecond = false
      this.dialogThird  = true
    },

    uploadUsingExperianStepIV(){
      this.dialogThird   = false
      this.dialogFourth  = true
      setTimeout(()=>{this.$refs.memberForm.reset()}, 300) 
    },

    getMemberDetail(e){

    },

    submit(){
      if(this.$refs.memberForm.validate() !=false){
         this.dialogFourth = false
         this.dialogFifth  = true
      }
    },

    setMemberData(e){
      this.exp_member_id = e
      this.pancard   = "";
      this.mobile_no = "";
      this.email     = "";
      if(e==0){
        Auth.currentAuthenticatedUser({
          bypassCache: false
        }).then(user => { 
          this.exp_member_name = user.attributes["custom:name"];
          this.email = user.attributes["email"];
          this.mobile_no = user.attributes["custom:phonenumber"].replace("+91", '');
          if(user.attributes["custom:pancard"] !=undefined){
            this.pancard = user.attributes["custom:pancard"];   
          }       
        })
      }
      else{
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        formdata.append("member_id", e);
        axios.post( process.env.VUE_APP_ROOT_API+'get-member-detail',
            formdata,{
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Control-Allow-Origin':'*'
            }
          }
        ).then((response) => { 
          this.exp_member_name =  response.data.data.name
          if(response.data.data.pan !="" || response.data.data.pan !='N/A' ){
            this.pancard = response.data.data.pan;   
          }
          if(response.data.data.email !="" || response.data.data.email !='N/A' ){
            this.email = response.data.data.email;   
          }
          if(response.data.data.mobile_no !="" || response.data.data.mobile_no !='N/A' ){
            this.mobile_no = response.data.data.mobile_no.replace("+91", '');
          }
        }).catch(() => {});
      }
    },

    uploadUsingExperianStepV(e){
      this.dialogFifth = false
      this.dialogSixth = true
    },

    uploadUsingExperianStepVI(e){
      if(document.getElementById('checkboxfield').checked == false){
        this.checkbox_error = true
        return false
      }
      this.$loading(true)
      let nameArr = this.exp_member_name.split(" ");
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      
      let formdata    = new FormData();
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("firstName", nameArr[0]);
      formdata.append("surName", nameArr[1]);
      formdata.append("mobileNo", this.mobile_no);
      formdata.append("email", this.email);
      formdata.append("pan", this.pancard);
      axios.post( process.env.VUE_APP_ROOT_API+'register-enhanced-match-mobile-otp',
          formdata,{
          headers: {
            'Access-Control-Allow-Origin':'*'
          }
        }
      ).then((response) => { 
          this.stgOneHitId = response.data.stgOneHitId
          this.stgTwoHitId = response.data.stgTwoHitId
          this.sendExpOtp()
      }).catch(() => {this.$loading(false) });

    },
    agree(e){
      if(document.getElementById('checkboxfield').checked == false){
        this.checkbox_error = true
      }
      this.checkbox_error = false
    },

    sendExpOtp(){
      let formdata    = new FormData();
      let cognito_idp = atob(localStorage.getItem('cognito_idp'));
      formdata.append("aws_cognito_id", cognito_idp);
      formdata.append("stgOneHitId", this.stgOneHitId);
      formdata.append("stgTwoHitId", this.stgTwoHitId);
      formdata.append("mobileNo", this.mobile_no);
      axios.post( process.env.VUE_APP_ROOT_API+'generate-exp-mobile-otp',
          formdata,{
          headers: {
            'Access-Control-Allow-Origin':'*'
          }
        }
      ).then((response) => { 
          this.masked_mob = "XXXXXX"+this.mobile_no.substr(-4)
          this.dialogSixth = true
          this.dialogSeventh = true
          setTimeout(()=>{this.$refs.submitExpOTPForm.reset()}, 500)
          this.$loading(false) 
      }).catch(() => {this.$loading(false) });
    },

    submitExpOTP(){
      if(this.$refs.submitExpOTPForm.validate() !=false){
          this.$loading(true)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          let formdata    = new FormData();
          formdata.append("aws_cognito_id", cognito_idp);
          formdata.append("stgOneHitId", this.stgOneHitId);
          formdata.append("stgTwoHitId", this.stgTwoHitId);
          formdata.append("otp", this.exp_otp);
          formdata.append("mobileNo", this.mobile_no);
          axios.post( process.env.VUE_APP_ROOT_API+'validate-exp-mobile-otp',
              formdata,{
              headers: {
                'Access-Control-Allow-Origin':'*'
              }
            }
          ).then((response) => { 
              console.log(response.data)
              if(response.data.showHtmlReportForCreditReport == null){
                swal.fire({
                  title: '',
                  text: response.data.errorString,
                  icon: 'warning',
                  showCancelButton: false,
                  confirmButtonColor: '#051d42',
                  //cancelButtonColor: '#d33',
                  confirmButtonText: 'OK',
                  //cancelButtonText:'No'
                })
                return false;
              }
              let cognito_idp = atob(localStorage.getItem('cognito_idp'));
              let formdata    = new FormData();
              formdata.append("aws_cognito_id", cognito_idp);
              formdata.append("member_id", this.exp_member_id);
              formdata.append("stgOneHitId", response.data.stgOneHitId);
              formdata.append("stgTwoHitId", response.data.stgTwoHitId);
              formdata.append("showHtmlReportForCreditReport", response.data.showHtmlReportForCreditReport);
              axios.post( process.env.VUE_APP_ROOT_API+'get-experian-data',
                  formdata,{
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'Access-Control-Allow-Origin':'*'
                  }
                }
              ).then((response) => { 
                this.exp_credit_score = response.data.credit_score
                setTimeout(()=>{this.dialogEightth = true}, 500)
                this.$loading(false)  
              }).catch(() => {this.$loading(false) });
              this.$loading(false) 
          }).catch(() => {this.$loading(false) }); 
      }
    },
  
    uploadOtherMemberDetail(){
      this.dialogEightth = false
      this.dialogFourth  = true
      setTimeout(()=>{this.$refs.memberForm.reset()}, 500) 
    },

    pushToDashboard(){
      this.$router.push({ name: "liabilities-dashboard", params: {}}).catch(()=>{});
    }
  }
}
</script>